module.exports = __webpack_public_path__ + "images/emoji/persevere.abe179d234e67b7ca4c8.png";